import React from "react";

export function GatewayStatusPill({ children, tone = "", className = "", indicator = false, ...props }) {
  return (
    <span className={`gwStatusPill${tone ? ` ${tone}` : ""}${className ? ` ${className}` : ""}`} {...props}>
      {indicator ? <span aria-hidden="true" /> : null}
      {children}
    </span>
  );
}

export function GatewayMetric({ label, value, detail = "", className = "" }) {
  return (
    <div className={className}>
      <span>{label}</span>
      <strong>{value}</strong>
      {detail ? <small>{detail}</small> : null}
    </div>
  );
}
